import { BaseComponent } from "../../../components/BaseComponent";
import React from "react";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { Button } from "../../../components/Buttons";
import styled from "styled-components";
import { Modal, ModalControls } from "../../../components/Modal";
import { VBox } from "../../../components/Box";
import { FormField, FormFields } from "../../../components/FormFields";
import { Input } from "../../../components/Form";

const STATE = {
  description: null,
};

const Container = styled.div``;

class InvoiceRelationSourceDetailsComp extends BaseComponent {

  constructor(props) {
    super(props, { description: props.description ?? STATE.description });
  }

  reset() {
    this.setState(prev => {
      return {
        ...prev,
        STATE,
      }
    });
  }
  onAdd() {
    const subject = {
      id: +(new Date()),
      description: this.state.description,
    };
    this.props.onAdd(subject);
  }

  onClose() {
    this.props.onClose();
  }

  render() {
    return (
      <Container>
        <Modal title={this.lbl('invoice.relationSource.title')}>
          <FormFields>
            <VBox>
              <p>{this.lbl('invoice.relationSource.description')}</p>
              <FormField>
                <Input
                  type="textarea"
                  name="description"
                  value={this.state.description ?? ''}
                  onChange={this.onInputChange.bind(this)}
                />
              </FormField>
            </VBox>
          </FormFields>
          <ModalControls>
            <Button
              disabled={false}
              onClick={this.onAdd.bind(this)}
            >
              {this.lbl('add')}
            </Button>
            <Button onClick={this.onClose.bind(this)}>{this.lbl('cancel')}</Button>
          </ModalControls>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceRelationSourceDetails = compose(
  withConnect,
  withRouter,
)(InvoiceRelationSourceDetailsComp);
